import { Box } from '@mui/material';
import React from 'react';

const ArrowDown = ({ fill = '#FF54C5', ...rest }) => (
  <Box {...rest}>
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.00069 9.5C4.05402 9.5 3.18734 8.9 2.56067 7.81333L0.780674 4.72667C0.147341 3.64 0.0673409 2.59333 0.540674 1.77333C1.01401 0.953333 1.96734 0.5 3.22067 0.5H6.78069C8.03402 0.5 8.98735 0.953333 9.46069 1.77333C9.93402 2.59333 9.84735 3.64667 9.22069 4.73333L7.44069 7.82C6.81402 8.9 5.94735 9.5 5.00069 9.5ZM3.22067 1.5C2.33401 1.5 1.69401 1.77333 1.40734 2.27333C1.11401 2.77333 1.20067 3.46667 1.64067 4.22667L3.42067 7.31333C3.86069 8.08 4.42069 8.5 4.99402 8.5C5.56735 8.5 6.12735 8.08 6.56735 7.31333L8.34735 4.22667C8.78735 3.46 8.87402 2.76667 8.58735 2.26667C8.30069 1.76667 7.65402 1.49333 6.77402 1.49333H3.22067V1.5Z"
        fill={fill}
      />
    </svg>
  </Box>
);

export default ArrowDown;
